<template>
  <v-card :height=getHeight>
    <v-card-title class="d-block light-blue lighten-2 headline text-xl-headline text-lg-h6 text-md-h6 text-truncate">
      <v-icon class="mr-2">{{icon}}</v-icon>
      <span class="font-weight-light">{{title}}</span>
    </v-card-title>
    <v-card-text>
      <slot name="chart"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: "chartCardContainer",
    props: ['icon', 'title', 'height'],
    computed: {
      getHeight() {
        return this.height ? this.height : 300;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/chartCardContainer.vue